export enum PartyIdentifierResults {
    partiesNotFound = 0,
    partiesFound = 1,
    partiesAlreadyReceived = 2,
}
